module.exports = __webpack_public_path__ + "static/media/Question-stroke-icon.c70ce409.svg";